import { SubRouteAttributes } from '@albatrosdeveloper/ave-models-package';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from 'app/core/i18n/translate.pipe';
import { ModalFrecuencyComponent } from '../../../sub-route-periodicity/modal-frecuency/modal-frecuency.component';

@Component({
  selector: 'app-frequency-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, ModalFrecuencyComponent, TranslatePipe],
  template: `
    <div class="flex h-full max-h-[90vh] flex-col">
      <div class="flex items-center justify-between border-b border-gray-200 px-4 py-2">
        <h2 class="text-lg font-semibold">
          {{ 'routing.SUB_ROUTE_PARTNERS.DIALOGS.FREQUENCY.TITLE' | t: { name: data.name } }}
        </h2>
        <button mat-icon-button mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="flex-1 overflow-auto">
        <app-modal-frecuency [data]="data" />
      </div>
    </div>
  `,
})
export class FrequencyDialogComponent {
  readonly dialogRef = inject(MatDialogRef<FrequencyDialogComponent>);
  readonly data: SubRouteAttributes = inject(MAT_DIALOG_DATA);
}
